import { v4 as uuidv4 } from "uuid";
import ValidationAndErrorHandling from "../shared/validation_and_error_handling";
import { applyImageCropper } from "./setup_image_cropper";
import CustomizationRequest from "../site_builder/customization/request";

export const applyImageHandling = (controller) => {
  const validation = new ValidationAndErrorHandling(
    controller.loaderTarget,
    controller.errorMessageTarget,
    controller.fromSiteBuilderValue,
  );
  applyImageCropper(controller);

  Object.assign(controller, {
    showImageDrawer() {
      if (this.fromSiteBuilderValue) {
        const url = "/library_files/images";
        CustomizationRequest.turboFetch(url);
      } else {
        this.mediaImageUploader.find(".open_drawer").trigger("click");
      }
      if (!this.thumbImgTarget.getAttribute("src")) {
        this.nextBtnTarget.style.display = "none";
        this.selectedThumbTarget.style.display = "none";
      } else {
        this.selectedThumbTarget.style.display = "inline-block";
      }
    },

    clearSelectedImage(container) {
      container.html("");
    },

    getImageType(cropper) {
      const imageType = cropper.crossOriginUrl.split(";")[0].split(":")[1];

      return imageType === "image/svg+xml" ? "image/svg" : imageType;
    },

    addUUIDToFileName(fileName) {
      const uuid = uuidv4();
      const lastDotIndex = fileName.lastIndexOf(".");
      const newFileName =
        fileName.slice(0, lastDotIndex) +
        "-" +
        uuid +
        fileName.slice(lastDotIndex);
      return newFileName;
    },

    async handleAddFile(e, initializeCropperMethod) {
      const file = e.target.files[0];

      if (!validation.handleFileValidation(file, this.isValidFileType.bind(this))) {
        return;
      }

      if (controller.fromSiteBuilderValue) {
        this.filenameTarget.textContent = file.name;
      }
      this.uploadedFile = file;
      this.showLoader(this.loaderTarget);
      validation.clearError();
      const reader = new FileReader();
      this.clearSelectedImage(this.cropperImageContainer);

      reader.onloadend = async () => {
        try {
          this.dataUrl = reader.result;
          const fileUploadCropper = await this.setupCropper(
            reader.result,
            this.cropperImageContainer,
            this.cropperSection,
            initializeCropperMethod
          );
          this.fileUploadCropper = fileUploadCropper;
          validation.hideLoader();
          this.goForward(this.dropSectionTarget, this.cropSectionTarget);
          validation.clearError();
        } catch (error) {
          console.error(error);
        }
      };

      reader.readAsDataURL(file);
    },
  });
};
